import React from 'react';

import HeaderMonarchLoggedOut from './HeaderMonarchLoggedOut';
import useHeaderLoggedOutMonarch from './logic/useHeaderLoggedOutMonarch';

import { MONARCH_HEADER_ID } from 'shared/components/NavigationBar';

export function HeaderMonarchLoggedOutController ({
  // To extend styling.
  className = 'header-webpp'
} = {}) {
  const { dispatch } = useHeaderLoggedOutMonarch();

  return (
    <HeaderMonarchLoggedOut
      className={className}
      dispatch={dispatch}
      headerID={MONARCH_HEADER_ID}
    />
  );
}

export default HeaderMonarchLoggedOutController;
